export const mensajesChat = {
  // NewConversationModal.vue — nueva conversación por WhatsApp
  newConversation: {
    nameTooShort: "Escribe el nombre con el que quieres que te reconozcan.",
    saveNameError: "No se pudo guardar el nombre comercial.",
    started: "Conversación iniciada.",
    sent: "Mensaje enviado.",
    startError: "No se pudo iniciar la conversación.",
    titleConnect: "Conecta tu WhatsApp",
    titleName: "Tu nombre comercial",
    titleNew: "Nueva conversación",
    subtitleConnect: "Hace falta para poder escribir tú primero",
    subtitleName: "Es el nombre con el que la persona te verá llegar",
    subtitleNew: "Escribe por WhatsApp a cualquier número",
    close: "Cerrar",
    senderStripPre: "Se enviará como",
    change: "Cambiar",
    connectBody:
      "Para escribir tú primero, el mensaje tiene que salir de <strong>tu propio número</strong> de WhatsApp Business. Con el número compartido de WACheckin la persona vería un teléfono que no es tuyo, y no podríamos presentarte con tu nombre comercial.",
    connectItem1: "Escribes a cualquier número, tenga reserva o no",
    connectItem2: "Tu nombre comercial aparece como remitente",
    connectItem3: "Las respuestas llegan a esta misma bandeja",
    connectFoot: "Se conecta una vez, desde Integraciones → WhatsApp.",
    previewLabel: "Así lo verá",
    previewGreeting: "Hola 👋",
    previewFromPre: "Te escribimos de",
    previewFromPost: ".",
    previewCtaPre: "Tenemos un mensaje para ti. Responde",
    previewOk: "Ok",
    previewCtaPost: "y te lo enviamos.",
    fallbackBusiness: "tu negocio",
    nameLabel: "Nombre comercial",
    namePlaceholder: "Casa Rural El Mirador",
    nameHelp:
      "Se guarda en Agente IA → Nuevas reservas, y puedes cambiarlo ahí o aquí cuando quieras.",
    recipientLabel: "Destinatario",
    messageLabel: "Mensaje",
    messagePlaceholder: "Escribe tu mensaje…",
    cancelSoft: "Ahora no",
    cancel: "Cancelar",
    connectBtn: "Conectar WhatsApp",
    continueBtn: "Continuar",
    sendBtn: "Enviar mensaje",
  },

  // MessageTranslate.vue — traducción por-mensaje en las burbujas del chat
  translate: {
    // BarraTraduccion.vue — la barra del traductor del chat (automático + previa)
    off: "Traducción automática apagada",
    on: "Traduciendo",
    turnOn: "Traducir lo que llega y ver antes lo que escribes",
    turnOff: "Apagar la traducción automática",
    guestWrites: "el huésped escribe en {idioma}",
    nothingToDo: "Nada que traducir: el huésped escribe en {idioma}",
    youRead: "Lo lees en",
    willBeSentIn: "lo que escribas se enviará en",
    pickOutgoing: "En qué idioma le llegará lo que escribas",
    theirs: "el suyo",
    willArriveAs: "Le llegará así, en {idioma}:",
    sendIn: "Enviar en {idioma}",
    cancel: "Cancelar",
    discard: "Descartar",
    enterSends: "Con Enter sale",
    translating: "Traduciendo…",
    translate: "Traducir",
    viewTranslation: "Ver traducción",
    viewOriginal: "Ver original",
    translated: "Traducido",
    copy: "Copiar",
    copied: "Copiado",
    error: "No se pudo traducir. Inténtalo de nuevo.",
  },

  // Phone.vue — vista previa del chatbot con estilo WhatsApp
  phone: {
    online: "En línea",
    today: "Hoy",
    sampleQuestion: "¿A qué hora es el check-in?",
    answerPlaceholder: "Escribe tu respuesta aquí...",
    inputPlaceholder: "Escribe un mensaje...",
  },

  // selectorTypeIframe.vue — selector de periodo de suscripción
  billing: {
    selectPeriod: "Selecciona periodo",
    selectPeriodHint: "Elige cómo quieres pagar",
    monthly: "Mensual",
    annual: "Anual",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "A quién escribes",
    modeOne: "Mensaje normal",
    modeGroup: "Mensaje masivo",
    allOtas: "Todas",
    needsWhatsapp: "Conecta tu WhatsApp para usar esta vía",
    connectNow: "Conectarlo",
    varsLabel: "Variable",
    vars: {
      nombre: "El nombre del huésped",
      alojamiento: "El nombre del alojamiento",
      entrada: "La fecha de entrada",
      salida: "La fecha de salida",
      codigo: "El código de la reserva",
    },
    remove: "Quitar",
    oneEach: "Cada huésped lo recibe una sola vez, por la primera vía disponible.",
    noContact: "1 sin forma de contacto | {count} sin forma de contacto",
    otaLabel: "Qué OTA",
    emoji: "Emoji",
    attach: "Adjuntar archivo",
    noFileOta: "El archivo no viaja por la OTA",
    previewLabel: "Así se leerá",
    fileTooBig: "«{name}» pesa {size} MB y el máximo por WhatsApp para este tipo es {max} MB",
    fileNotAllowed: "Solo se admiten imágenes (JPG, PNG, GIF), PDF y vídeo MP4: WhatsApp no reproduce otros formatos.",
    attachHint: "Imágenes y PDF hasta 10 MB · vídeo MP4 hasta 15 MB",
    channelLabel: "Por dónde",
    channels: { whatsapp: "WhatsApp", email: "Correo", ota: "OTA" },
    groupLabel: "Qué huéspedes",
    groups: {
      alojados: "Alojados ahora",
      entran_hoy: "Entran hoy",
      entran: "Entran pronto",
      salen: "Salen hoy",
    },
    withinPre: "en los próximos",
    withinPost: "día | días",
    empty: "No hay huéspedes en este grupo ahora mismo.",
    reachOf: "de {total} lo recibirá | de {total} lo recibirán",
    queuedSilently: "A 1 no le llega aviso hoy: ya tenía uno pendiente | A {count} no les llega aviso hoy: ya tenían uno pendiente",
    noChannel: {
      whatsapp: "1 sin teléfono | {count} sin teléfono",
      email: "1 sin correo | {count} sin correo",
      ota: "1 sin hilo de OTA | {count} sin hilo de OTA",
    },
    billed: "1 conversación de WhatsApp se factura | {count} conversaciones de WhatsApp se facturan",
    showList: "Ver el destinatario | Ver los {count} destinatarios",
    hideList: "Ocultar la lista",
    noName: "Sin nombre",
    states: {
      directo: "le llega",
      plantilla: "invitación",
      en_cola: "ya tenía una pendiente",
      sin_telefono: "sin teléfono",
      sin_correo: "sin correo",
      sin_hilo_ota: "sin hilo",
      sin_contacto: "sin contacto",
    },
    sending: "Enviando a 1 huésped | Enviando a {count} huéspedes",
    sendGroup: "Enviar a 1 huésped | Enviar a {count} huéspedes",
    historial: {
      providerId: "Identificador del proveedor. Con él se busca el mensaje en la consola de SES.",
      sentMeans: "«Salió» quiere decir que el proveedor lo aceptó. Que el huésped lo lea, o que no acabe en no deseados, ya no depende de nosotros.",
      estados: {
        enviando: "Saliendo",
        enviado: "Salió",
        en_cola: "En cola",
        fallo: "No salió",
        sin_contacto: "Sin forma de contacto",
      },
      title: "Envíos a grupos",
      subtitle: "Lo que se ha mandado, a quién y qué pasó con cada uno",
      empty: "Todavía no has mandado ningún mensaje a un grupo.",
      error: "No se pudo cargar el historial.",
      sentBy: "por {quien}",
      running: "En marcha",
      back: "Volver",
      messageLabel: "El mensaje",
      recipientsLabel: "Destinatarios",
      colName: "Huésped",
      colVia: "Por dónde",
      colDest: "A dónde",
      colState: "Qué pasó",
      openChat: "Abrir",
      attachment: "Adjunto: {nombre}",
      close: "Cerrar",
      reached: "{enviados} de {total}",
      noOne: "Sin nombre",
    },
  },
};
